import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ContentBlock } from 'draft-js';
import { List } from 'immutable';
import { BlockType } from '@uno/common-cms';

/**
 * Converts ContentBlockConfig to ContentBlock
 */
export var toFlatContentBlocks = function toFlatContentBlocks(blockConfigs) {
  return blockConfigs.map(function (config) {
    var _extractTextFromBlock = extractTextFromBlockConfigs(config.childConfigs),
        text = _extractTextFromBlock.text,
        characterList = _extractTextFromBlock.characterList;

    return new ContentBlock(_objectSpread(_objectSpread({}, config), {}, {
      text: config.text + text,
      characterList: List(config.characterList.concat(characterList))
    }));
  });
};
/**
 * Extract the text and the associated inline styles form an
 * array of content block configs.
 */

export var extractTextFromBlockConfigs = function extractTextFromBlockConfigs(blockConfigs) {
  return blockConfigs.reduce(function (_ref, config) {
    var text = _ref.text,
        characterList = _ref.characterList;
    text += config.text;
    characterList = characterList.concat(config.characterList);

    if (text !== '' && config.type !== BlockType.UNSTYLED) {
      characterList.push(characterList[characterList.length - 1]);
    }

    var children = extractTextFromBlockConfigs(config.childConfigs);
    text += children.text;
    characterList = characterList.concat(children.characterList);
    return {
      text: text,
      characterList: characterList
    };
  }, {
    text: '',
    characterList: []
  });
};